// API Configuration - Central place to manage all endpoint URLs
import authService from '../services/authService'

// Shared API configuration function
export const getApiConfiguration = () => {
  // Get token from authService (will use sessionStorage)
  const token = authService.getAccessToken()
  
  return {
    basePath: import.meta.env.VITL_API_BASE_URL || '/api',
    authorization: token || ''
  }
}

export const API_CONFIG = {
  // Base URL - uses environment variable or defaults to /api for vite proxy
  get BASE_URL() { return getApiConfiguration().basePath },
  
  // Patient endpoints
  PATIENTS: {
    LIST: '/patients',
    CREATE: '/patients',
    UPDATE: (patientId: string) => `/patients/${patientId}`,
    DELETE: (patientId: string) => `/patients/${patientId}`,
  },
  
  // Prescription endpoints
  PRESCRIPTIONS: {
    LIST: '/prescriptions',
    CREATE: '/prescriptions',
    DETAIL: (prescriptionId: string) => `/prescriptions/${prescriptionId}`,
    UPDATE: (prescriptionId: string) => `/prescriptions/${prescriptionId}`,
  },
  
  // Order endpoints  
  ORDERS: {
    LIST: '/orders',
    CREATE: '/orders',
    DETAIL: (orderId: string) => `/orders/${orderId}`,
  },
  
  // Medication & Formulary endpoints
  MEDICATIONS: {
    LIST: '/medications',
  },
  
  FORMULARIES: {
    LIST: '/formularies',
    PRICING: (formularyId: string) => `/formularies/${formularyId}/pricing`,
  },
  
  // Clinic & Pharmacy endpoints
  CLINICS: {
    LIST: '/clinic',
  },
  
  PHARMACIES: {
    LIST: '/pharmacies',
  },
  
  // Invoice endpoints
  INVOICES: {
    LIST: '/invoices',
    DETAIL: (invoiceId: string) => `/invoices/${invoiceId}`,
  },
}

// Helper function to build URLs with query parameters
export const buildUrl = (baseUrl: string, params?: Record<string, string | number | undefined>) => {
  if (!params) return baseUrl
  
  const searchParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      searchParams.append(key, String(value))
    }
  })
  
  const queryString = searchParams.toString()
  return queryString ? `${baseUrl}?${queryString}` : baseUrl
}